// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", sans-serif;
  background-color: #02040A;
  /* background-image: url("https://tapimages.gaming.5ire.network/top-ellipse.png"); */
  color: white;
  background-position: center -600px;
  background-size: contain;
  background-repeat: no-repeat;
}

img,
svg,
canvas,
iframe,
video {
  max-width: 100%;
}

a,
span {
  display: inline-flexbox;
}

#root {
  padding: 100px 0;
}

@media (max-width: 499px) {
  #root {
    padding: 30px 0;
  }
}

#root .logo img {
  background-color: #131415;
  padding: 20px 10px;
  border-radius: 10px;
  width: 100%;
  object-fit: contain;
  height: 200px;
}

@media (min-width: 1400px) {
  .logo h1 {
    font-size: 44px;
  }
}

.logo h1 {
  margin: 20px 0;
}

.container {
  max-width: 900px;
  margin: 0 auto;
}

img:has(+img),
img:has(+img)+img {
  padding: 5px;
  width: 50%;
}

.table {
  white-space: nowrap;
  vertical-align: middle;
  --bs-table-bg: transparent;

  td,
  th {
    color: white;
    border-bottom-color: rgba(255, 255, 255, 0.2);
  }
}

img {
  width: 360px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,oFAAoF;EACpF,YAAY;EACZ,kCAAkC;EAClC,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EAEX,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;;EAE1B;;IAEE,YAAY;IACZ,6CAA6C;EAC/C;AACF;;AAEA;EACE,YAAY;AACd","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: \"Inter\", sans-serif;\n  background-color: #02040A;\n  /* background-image: url(\"https://tapimages.gaming.5ire.network/top-ellipse.png\"); */\n  color: white;\n  background-position: center -600px;\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\nimg,\nsvg,\ncanvas,\niframe,\nvideo {\n  max-width: 100%;\n}\n\na,\nspan {\n  display: inline-flexbox;\n}\n\n#root {\n  padding: 100px 0;\n}\n\n@media (max-width: 499px) {\n  #root {\n    padding: 30px 0;\n  }\n}\n\n#root .logo img {\n  background-color: #131415;\n  padding: 20px 10px;\n  border-radius: 10px;\n  width: 100%;\n  -o-object-fit: contain;\n  object-fit: contain;\n  height: 200px;\n}\n\n@media (min-width: 1400px) {\n  .logo h1 {\n    font-size: 44px;\n  }\n}\n\n.logo h1 {\n  margin: 20px 0;\n}\n\n.container {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\nimg:has(+img),\nimg:has(+img)+img {\n  padding: 5px;\n  width: 50%;\n}\n\n.table {\n  white-space: nowrap;\n  vertical-align: middle;\n  --bs-table-bg: transparent;\n\n  td,\n  th {\n    color: white;\n    border-bottom-color: rgba(255, 255, 255, 0.2);\n  }\n}\n\nimg {\n  width: 360px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
